// src/components/CreditsModal.jsx
import React, { useEffect, useState } from 'react'
import axios                           from 'axios'
import { useDispatch, useSelector }   from 'react-redux'
import { base_url }                    from '../utils/config'
import CreditsPurchaseModal           from './CreditsPurchaseModels'
import { trackVirtualAction }         from '../store/reducers/customerVirtualActivitySlice'
import { trackProductAction }         from '../store/reducers/productVirtualActivitySlice'

export default function CreditsModal({ onClose }) {
  const dispatch = useDispatch()
  const userId   = useSelector(s => s.auth.userInfo.id)
  const token    = useSelector(s => s.auth.token)
  const credits  = useSelector(s => s.credits.remaining)

  const [history, setHistory] = useState([])
  const [showBuy, setShowBuy] = useState(false)

  // track modal open
  useEffect(() => {
    dispatch(trackVirtualAction({ userId, actionType: 'open_credits_modal' }))
    dispatch(trackProductAction({ productId: null, actionType: 'open_credits_modal' }))
  }, [dispatch, userId])

  useEffect(() => {
    // fetch usage history
    axios.get(`${base_url}/api/credits/history`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(r => setHistory(r.data.history || []))
    .catch(() => setHistory([]))
  }, [token])

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-80 p-6 relative">
        <button
          className="absolute top-2 right-2 text-gray-500"
          onClick={onClose}
        >✕</button>

        <h2 className="text-xl font-semibold mb-2">Your Credits</h2>
        <p className="text-3xl font-bold text-green-600 mb-4">
          {credits} remaining
        </p>

        <div className="mb-4">
          <h3 className="font-medium">Usage History</h3>
          {history.length === 0
            ? <p className="text-sm text-gray-500">No usage yet.</p>
            : (
              <ul className="list-disc pl-5 text-sm text-gray-700">
                {history.map((h,i) => (
                  <li key={i}>
                    Used {h.used} on {new Date(h.timestamp).toLocaleString()}
                  </li>
                ))}
              </ul>
            )
          }
        </div>

        <div className="mb-4">
          <h3 className="font-medium">How credits work</h3>
          <ul className="list-disc pl-5 text-sm text-gray-700">
            <li>30 free credits reset every month on the 1st (unless you’ve purchased a pack)</li>
            <li>1 credit = 1 virtual try-on</li>
            <li>Unused credits carry until spent (max 30)</li>
          </ul>
        </div>

        <button
          className="w-full py-2 bg-green-600 text-white rounded mb-2 hover:bg-green-700"
          onClick={() => {
            setShowBuy(true)
            dispatch(trackVirtualAction({ userId, actionType: 'credits_purchase_initiate' }))
            dispatch(trackProductAction({ productId: null, actionType: 'credits_purchase_initiate' }))
          }}
        >
          Buy More Credits
        </button>
        <button
          className="w-full py-2 text-gray-600"
          onClick={onClose}
        >
          Close
        </button>
      </div>

      {showBuy && (
        <CreditsPurchaseModal onClose={() => setShowBuy(false)} />
      )}
    </div>
  )
}
